import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import FormCompareListComponent from 'webapp/components/form/compare/list';
import type { Item } from 'webapp/components/form/range/list-base';
import type { Args } from 'webapp/components/popup/inner/context';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

import type DsCompare from 'webapp/models-custom/ds-compare';

export default class FormComparePopupComponent extends PopupInnerContextComponent<PopupData.Form.Compare> {
	@service('analytics') declare analyticsService: Service.Analytics;

	initialCompare: DsCompare;

	@tracked selectedCompareId;
	@tracked selectedCompare: DsCompare | null = null; // updated from nested component through `selectItem`

	constructor(owner: Owner, args: Args) {
		super(owner, args);
		this.analyticsService.event(TrackingEvent.COMPARE_DROPDOWN_OPENED, {
			origin: this.popupData.trackingOrigin,
		});

		this.args.model.on('closing', this, this.onPopupClosing);

		if (this.popupData.compare) {
			this.initialCompare = this.popupData.compare;
		} else {
			this.initialCompare = this.metricLimitations.compare!; // for legacy where there was only one compare
		}

		if (this.initialCompare) {
			this.selectedCompareId = this.initialCompare.selectionId; // only for legacy - to show selection
		}
	}

	get metricLimitations() {
		return this.popupData.metricLimitations;
	}

	get exceptionIds() {
		return this.popupData.exceptionIds || [];
	}

	get showOtherMetricCompare() {
		return !!this.popupData.showOtherMetricCompare;
	}

	onPopupClosing() {
		// trigger the change
		if (
			this.initialCompare &&
			this.selectedCompare &&
			!this.initialCompare.isEqual(this.selectedCompare.getFormula())
		) {
			this.popupData.onChange(this.selectedCompare);
		}
	}

	@action
	selectItem(item: Item, skipClose = false) {
		this.selectedCompare = item as DsCompare;

		if (!skipClose) {
			this.close();
		}
	}
	<template>
		<FormCompareListComponent
			@theme={{@model.theme}}
			@initialCompare={{this.initialCompare}}
			@metricLimitations={{this.metricLimitations}}
			@exceptionIds={{this.exceptionIds}}
			@showOtherMetricCompare={{this.showOtherMetricCompare}}
			@onSelectItem={{this.selectItem}}
			@onContentChange={{this.reposition}}
		/>
	</template>
}
